async function request(url, options = {}) {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  if (response.status === 401) {
    window.location.href = `/api/auth/login?redirect=${encodeURIComponent(window.location.href)}`;
    throw new Error('Authentication required');
  }

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Request failed with status ${response.status}`);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export const api = {
  authStatus() {
    return request('/api/auth/status');
  },
  listPlannerBudgets() {
    return request('/api/planner/budgets/');
  },
  getPlannerBudget(id) {
    return request(`/api/planner/budgets/${id}`);
  },
  refreshPlannerBudget(id) {
    return request(`/api/planner/refresh/${id}`, {
      method: 'POST',
      cache: 'no-store',
      body: '{}',
    });
  },
  savePlannerBudget(payload) {
    return request('/api/planner/budgets/', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
    async syncPlannerBudget(id, payload) {
    try {
      const response = await request(`/api/planner/sync/${id}`, {
        method: 'POST',
        body: JSON.stringify(payload || {}),
      });
      return response;
    } catch (error) {
      console.error('Sync error:', error);
      throw error;
    }
  },
  getPlannerAccountTags(accountId) {
    return request(`/api/planner/account-tags/${accountId}`);
  },
  deletePlannerTaggedTransactions(accountId, payload) {
    return request(`/api/planner/account-tags/${accountId}/delete`, {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  },
  restorePlannerRun(runId) {
    return request(`/api/planner/restore/${runId}`, {
      method: 'POST',
    });
  },
  getPlannerReference() {
    return request('/api/planner/reference/');
  },
  async exportPlannerBudget(id) {
    const response = await fetch(`/api/planner/export/${id}`);
    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || `Request failed with status ${response.status}`);
    }
    return response.blob();
  },
  async importPlannerBudget(file, budgetId) {
    const form = new FormData();
    form.append('file', file);
    if (budgetId) {
      form.append('budget_id', String(budgetId));
    }
    const response = await fetch('/api/planner/import/', {
      method: 'POST',
      body: form,
    });
    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || `Request failed with status ${response.status}`);
    }
    return response.json();
  },
  deactivateSubscriptions(payload) {
    return request('/api/planner/deactivate-subscriptions/', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
